<div
  class="flex flex-col justify-center items-stretch"
  *ngIf="attribute$ | async as attribute"
>
  <h2>Updating {{ attribute.name }}</h2>
  <app-key-value-pair
    key="update-attribute-value-current-value"
    name="Current value"
    [value]="attribute.latest_value | attributeValue : attribute.data_type"
  ></app-key-value-pair>
  <app-key-value-pair
    key="update-attribute-value-last-updated"
    name="Last Updated"
    [value]="attribute.current_value | attributeValueTimestampUser | async"
  ></app-key-value-pair>
  <app-attribute-value-input
    testId="update-attribute-value-new-value"
    [formControl]="formControl"
    label="New Value"
    [type]="attribute.data_type"
  ></app-attribute-value-input>

  <div class="flex flex-row justify-center items-center">
    <button
      mat-flat-button
      color="primary"
      (click)="updateValue(attribute.id)"
      testId="update-single-attribute-save"
    >
      Save
    </button>
    <button
      mat-flat-button
      (click)="cancel()"
      testId="update-single-attribute-cancel"
    >
      Cancel
    </button>
  </div>
</div>
